import WaybillsTableColumnAsMoney from './index.vue'
export default WaybillsTableColumnAsMoney